import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface RefreshTokenResponse {
  accessToken: string;
  refreshToken?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  constructor(private http: HttpClient) {}

  refreshToken(refreshToken: string, accessToken?: string): Observable<RefreshTokenResponse> {
    const refreshEndpoint = `${environment.apiBaseUrl}${environment.auth.refreshEndpoint}`;
    const body = {
      refreshToken,
      accessToken,
      token: accessToken,
    };
    const headers = new HttpHeaders({
      'X-Skip-Auth-Refresh': 'true',
    });

    return this.http.post<any>(refreshEndpoint, body, { headers }).pipe(
      map((response) => this.normalizeRefreshResponse(response))
    );
  }

  revokeToken(refreshToken: string, accessToken?: string): Observable<void> {
    const revokeEndpoint = `${environment.apiBaseUrl}${environment.auth.revokeEndpoint}`;
    const body = {
      refreshToken,
      accessToken,
      token: accessToken,
    };
    const headers = new HttpHeaders({
      'X-Skip-Auth-Refresh': 'true',
    });

    return this.http.post<void>(revokeEndpoint, body, { headers });
  }

  private normalizeRefreshResponse(response: any): RefreshTokenResponse {
    const root = response?.data || response?.result || response;
    const accessToken = root?.token || root?.accessToken;
    const refreshToken = root?.refreshToken || root?.newRefreshToken;

    if (!accessToken) {
      throw new Error('Refresh response without access token');
    }

    return {
      accessToken,
      refreshToken,
    };
  }
}